import { NavigateFunction } from 'react-router-dom';

import { featureFlags } from '../../config/featureFlags';
import { User } from '../../types';
import { canAccessAdmin, isAdmin } from '../../utils/auth';
import {
  MenuItem,
  aboutMenuItem,
  accommodationMenuItem,
  adminPanelMenuItem,
  belhopPlusMenuItem,
  bookingsMenuItem,
  conciergeEnquiryMenuItem,
  discoverMenuItem,
  requestsMenuItem,
  servicesMenuItem,
  userProfileMenuItem,
  wishlistMenuItem,
} from './MenuItems';

/**
 * Core nav items split into the two visually-separated desktop groups:
 * primary destinations on the left, secondary/informational destinations
 * (with a gap between them) on the right.
 */
export const getCoreNavigationGroups = (_user?: User) => {
  const primary: MenuItem[] = [discoverMenuItem, accommodationMenuItem, servicesMenuItem];
  const secondary: MenuItem[] = [conciergeEnquiryMenuItem, belhopPlusMenuItem, aboutMenuItem];

  return { primary, secondary };
};

export const getCoreNavigationItems = (_user?: User) => {
  const { primary, secondary } = getCoreNavigationGroups(_user);
  return [...primary, ...secondary];
};

export const getUserMenuItems = (userFirstName: string, user: User | null) => {
  const items = [userProfileMenuItem(userFirstName)];
  if (featureFlags.wishlist) {
    items.push(wishlistMenuItem);
  }
  items.push(bookingsMenuItem);
  items.push(requestsMenuItem);
  if (canAccessAdmin(user)) {
    items.push(adminPanelMenuItem);
  }
  return items;
};

export const getAllNavigationItems = (userFirstName: string, user: User | null) => {
  return [...getCoreNavigationItems(), ...getUserMenuItems(userFirstName, user)];
};

export const getHomePath = (user?: User | null): string => {
  return isAdmin(user ?? null) ? '/admin' : '/';
};

export const handleMenuItemClick = (item: MenuItem, navigate: NavigateFunction) => {
  if (item.external) {
    window.open(item.path, '_blank');
  } else if (item.hash) {
    navigate(item.path);
    setTimeout(() => {
      const element = document.querySelector(item.hash!);
      element?.scrollIntoView({ behavior: 'smooth' });
    }, 100);
  } else {
    navigate(item.path, item.state ? { state: item.state } : undefined);
  }
};
